export default "__VITE_ASSET__Di65YyFc__"